export default class MouseStalker {
  constructor(config) {
    this.config = config
    this.stalkerClassName = this.config.stalkerClassName || 'mouse_stalker'
    this.hoverClass = this.config.hoverClass || 'mouse_stalker-link'
    this.stalkerElm
    this.scrub = this.config.scrub || 0.1
    this.stalkerPos = {
      x: document.documentElement.clientWidth * 0.9,
      y: document.documentElement.clientHeight * 0.9
    }
    this.mousePos = {
      x: document.documentElement.clientWidth * 0.9,
      y: document.documentElement.clientHeight * 0.9
    }

    // タッチデバイスだったら処理を終了する
    if (this.isTouchDevice()) return

    this.createStalker() // マウスストーカーのエレメントの作成
    document.addEventListener('mousemove', (e) => this.mousePosUpdate(e)) // mouseの位置セット

    requestAnimationFrame(this.stalkerPosUpdate)
    this.hoverAction()
  }

  createStalker() {
    let div = document.createElement('div')
    div.classList.add(this.stalkerClassName)
    div.style.position = 'fixed'
    div.style.top = 0
    div.style.left = 0
    div.style.zIndex = 999
    div.style.pointerEvents = 'none'

    this.stalkerElm = div

    document.body.appendChild(div)
  }

  mousePosUpdate(e) {
    this.mousePos = {
      x: e.clientX,
      y: e.clientY
    }
  }
  stalkerPosUpdate = () => {
    this.stalkerPos.x += (this.mousePos.x - this.stalkerPos.x) * this.scrub
    this.stalkerPos.y += (this.mousePos.y - this.stalkerPos.y) * this.scrub
    const x =
      Math.round(this.stalkerPos.x * 10) / 10 - this.stalkerElm.clientWidth / 2
    const y =
      Math.round(this.stalkerPos.y * 10) / 10 - this.stalkerElm.clientWidth / 2
    this.stalkerElm.style.transform = `translate3d(${x}px, ${y}px, 0)`

    requestAnimationFrame(this.stalkerPosUpdate)
  }

  hoverAction() {
    // hover時にclass追加
    const linkObj = document.querySelectorAll(`a, button, .${this.hoverClass}`)
    linkObj.forEach((elm, i) => {
      elm.addEventListener('mouseover', () => {
        this.stalkerElm.classList.add('active')
      })
      elm.addEventListener('mouseout', () => {
        this.stalkerElm.classList.remove('active')
      })
    })
  }

  isTouchDevice() {
    if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
      return true
    } else {
      return false
    }
  }
}
